export const IMAGE_PATH = process.env.PUBLIC_URL + "/assets/images";
